import { IA2F, ILogin } from "../../interfaces/ILogin";
import fetcher, { IFetcher } from "../../libs/fetcher";

export const signon = async ({
    username,
    password,
    token,
    app,
}: ILogin): Promise<IFetcher> => {
    try {
        const response = await fetcher({
            url: `/signon/${app}`,
            method: 'POST',
            data: { username, password, token },
        });
        // console.log("🚀 ~ file: auth.ts:17 ~ response:", response)
        if (response?.fetch === undefined) {
            throw new Error('Request failed');
        }
        const { fetch, cancel } = response;
        return { fetch, cancel };
    } catch (error: any) {
        return { fetch: error, cancel: () => { } };
    }
};



export const verifySignon = async ({ username, code, token, app }:ILogin): Promise<IFetcher> => {
    try {
        const response = await fetcher({
            url: `/verify_code`,
            method: 'POST',
            data: { username, code, app, token }
        });
        if (response === undefined) {
            throw new Error('Request failed');
        }
        const { fetch, cancel } = response;
        return { fetch, cancel };
    } catch (error: any) {
        return { fetch: error, cancel: () => { } };
    }
};

export const twoFactorAuth = async ({ user_id, has_two_factor }: IA2F): Promise<IFetcher> => {
    try {
        const response = await fetcher({
            url: `/users/${user_id}/two_factor_auth`,
            method: 'PUT',
            data: { has_two_factor }
        });
        if (response === undefined) {
            throw new Error('Request failed');
        }
        const { fetch, cancel } = response;
        return { fetch, cancel };
    } catch (error: any) {
        return { fetch: error, cancel: () => { } };
    }
};
